import { getUser, logOut } from '../util/LoginUser'
import { Avatar, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Popover } from '@mui/material'
import { useState } from 'react'
import Box from '@mui/material/Box'
import OtherHousesIcon from '@mui/icons-material/OtherHouses'
import { Link } from 'react-router-dom'
import StorefrontIcon from '@mui/icons-material/Storefront'
import PeopleIcon from '@mui/icons-material/People'

const UserInfo = (props) =>{

  const [popoverOpen,setPopoverOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handler = (e) => {
    setPopoverOpen(true);
    setAnchorEl(e.currentTarget);
  }
  const handleClose = () => {
    setAnchorEl(null);
    setPopoverOpen(false);
  };

  const changeStatus = () => {
    props.logout(false);
    logOut();
  };


  return (
    <>
      <Avatar sx={{ bgcolor: 'primary.main' }} onClick={handler}>{getUser().id.slice(0,1).toUpperCase()}</Avatar>
      <Popover open={popoverOpen} onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
           vertical: 'top',
           horizontal: 'center',
         }} anchorEl={anchorEl}>
        <Box sx={{width:210,top: 100,paddingBlock:0,m:0}} >
          <List>
            <ListItem>
              <ListItemIcon >
                <OtherHousesIcon />
              </ListItemIcon>
              <Link to="/setting" >
                <ListItemText sx={{ml:2}} primary="ユーザ設定" />
              </Link>
            </ListItem>
            <ListItem>

              <ListItemIcon>
                <StorefrontIcon />
              </ListItemIcon>
              <ListItemButton onClick={(e) => {changeStatus()}}>
                <ListItemText primary="ログアウト" />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Popover>

    </>
  );


}

export default UserInfo